module.exports = __webpack_public_path__ + "img/arrow-right-btn-mouseover.4d9d2490.svg";